import { loggerShowUserInfo } from "@/utils/event";
import { NEED_USER_INFO_PATH_LIST, NEED_DIALOG_PATH_LIST } from "@/constants/route";
import { LOGIN_STATUS_ERROR_CODE } from "@/utils/ajax";

import {
    fetchUserInfo,
    fetchUserQualification,
    getWhiteBool,
    getEffectingRate,
    UserInfoData,
    UserQualificationData,
    UserEffectingRate,
    gerReportWhiteList,
} from "@/utils/fetch";
import { ref } from "vue";
import { useRouter } from "vue-router";

// todo provide 异步数据，inject 拿不到

export const userInfo = ref<UserInfoData>();

export const isWhiteList = ref<boolean>();

export const reportWhiteList = ref<Record<string, boolean>>();

export const effectingRate = ref<UserEffectingRate>();

const loginUrl = ref<string>();
export const qualification = ref<UserQualificationData>();

interface NoLoginError {
    code: string;
    loginUrl: string;
}
const isNoLoginError = (payload: any): payload is NoLoginError => {
    if (payload?.code && LOGIN_STATUS_ERROR_CODE.includes(parseInt(payload.code, 10))) {
        return true;
    }
    return false;
};

// 判断该路径是否需要用户信息
const isNeedUserInfoPath = () => {
    const currentPath = location.pathname;
    return NEED_USER_INFO_PATH_LIST.filter((path) => {
        return currentPath.startsWith(path);
    }).length;
};

// 判断该路径是否需要新费率弹窗
const isNeedDialogPath = () => {
    const currentPath = location.pathname;
    return NEED_DIALOG_PATH_LIST.filter((path) => {
        return currentPath.startsWith(path);
    }).length;
};

export const useUserInfo = () => {
    const router = useRouter();

    const getUserInfo = async () => {
        if (isNeedUserInfoPath()) {
            try {
                const promiseRes = await Promise.all([fetchUserInfo(), fetchUserQualification()]);
                const [userInfoRes, qualificationRes] = promiseRes;
                const result = {
                    ...userInfoRes.data,
                };
                userInfo.value = result;
                isWhiteList.value = await getWhiteBool();
                effectingRate.value = await getEffectingRate();

                reportWhiteList.value = await gerReportWhiteList();

                qualification.value = qualificationRes.data;
                loggerShowUserInfo({
                    userInfo: userInfoRes.data,
                    qualification: qualificationRes.data,
                });
            } catch (error) {
                // 没有登录态，保存loginUrl，点击登录时跳转
                if (isNoLoginError(error)) {
                    loginUrl.value = error.loginUrl;
                    return;
                }

                // 其他异常处理
                /**
                 * 为什么不在接口返回拦截器中处理？
                 * 因为可能每个接口异常的处理逻辑不一致：
                 * 1. 基础用户信息决定用户能否进入到指定页面，如果报错跳转到错误页
                 * 2. 其他业务接口报错，可能不影响页面整体展示，因此在拦截器中toast，在页面内做兜底处理
                 */
                router.replace({
                    name: "error",
                    query: {
                        message: (error as any)?.message,
                        code: (error as any)?.code,
                    },
                });
            }
        }
    };

    return {
        userInfo,
        loginUrl,
        qualification,
        getUserInfo,
        isWhiteList,
        reportWhiteList,
        effectingRate,
        isNeedDialogPath,
    };
};
